import ConfigApi from '../config';
import Q from 'q';
import router from '@/router/index';
// import { cloneDeep } from 'lodash';

let CancelToken;
let source;

const Config = require('~/config/default.env').default;

export default {
  namespaced: true,
  state: {
    productRecomendation: '',
    recentlySearch: '',
    recentlySearchFetched: false,
    department_menu: [],
    brands_menu: [],
    brands_menu_by_alphabet: [],
    brands_country: [],
    brands_country_by_alphabet: [],
    current_menu: [],
    loadingCart: false,
    dataOrder: {},
    mini_cart: [],
    product_carts_oos: [],
    recentBroughts: [],
    cart_error: false,
    cart_updating: false,
    cart_adding: false,
    cart_price_total: { cart: 0, discount: 0, delivery: 0 },
    cart_fetched: false,
    cart_data_fetched: false,
    cart_processing: false,
    cart_qty: 0,
    cart_id: '',
    show_search_form: false,
    redeem_beauty_points: '',
    redeem_voucher: '',
    voucher_code: '',
    order_nav: [],
    order_nav_current: '',
    isShowPopupUser: false,
    statusCart: false,
    invalid_voucher_message: '',
    modalNotify: false,
    modalCartConfirm: false,
    addCartType: '',
    detailVoucher: {},
    freeShipping: {},
    isFreeShipping: false,
    modalSocoPoints: '',
    showGwp: false,
    gwpText: '',
    socoPoint: [],
    banner_teaser: '',
    banner_floating: '',
    modalPackNotif: false,
    modalSuccess: false,
    load_recently_bought: false,
    campaignStatus: false,
    list_campaign_banner: false,
    stickyMobileData: {
      menuStickyMobileActive: '',
      listCategoryMobile: {},
      tabCategoryActive: '',
      unlockBadges: '',
      profile: '',
      totalPaymentConfirmation: '',
    },
    list_wishlist: [],
    list_special_price: [],
    voucherPaperBag: [],
    loadingVoucherPaperBag: false,
    list_people_also_buy: [],
    page_info_to: '',
    page_info_title: '',
    bpomBanner: '',
    promo_text: [],
    loading_banner: true,
    intersection: {
      sociolla_exclusive: [],
    },
    loading_intersection: {
      sociolla_exclusive: true,
    },
    isQuickTourEnabled: false,
    emergencies: [],
    main_banner: [],
    brand_launch: [],
    brand_launch_small: [],
    daily_deals: [],
    daily_deals_title: [],
    flash_sale_theme: '',
    flexible_banner: [],
    featured_brand_title: [],
    floating_icon_apps: [],
    sociolla_logo_thematic: [],
    open_method: true,
    quick_tour_state: '',
    quick_tour_visited: [],
    data_purchase_multiple: '',
    searchbar_promo_text: [],
    title_flexible_banner: [],
    call_all_banner: 0,
    loadingSpecialPrice: false,
    banner_called: false,
    popup_banner_closed: false,
    show_sticky_free_shipping: false,
    sticky_free_shipping: null,
    voucherCode: '',
    tours: [],
    first_fetched: {
      wishlist: false,
      special_price: false,
    },
    processing: {
      wishlist: false,
      special_price: false,
    },
    skip: {
      wishlist: 0,
      special_price: 0,
    },
    limit: {
      wishlist: 5,
      special_price: 5,
    },
    all_banner_processing: false,
    promotion_fetched: [],
    id_history: '',
    id_feedback: '',
    isSubmitFeedback: false,
    listFeedback: [],
    textFeedback: '',
    is_category_loading: false,
    omnichannel_data: {
      carts: {},
      order_id: '',
      show_modal: false,
      state: '',
      shipping_type: '',
      pick_up_store: {},
      is_omnichannel: false,
      pickup_date: '',
      latitude: '',
      longitude: '',
    },
    omnichannel_data_session: {},
    set_omnichannel_tours: {
      cart_page: '',
      shipping_page: '',
    },
    change_omnichannel: '',
    omnichannel_stores_stock: false,
    omnichannel_stores_stock_loading: false,
    omnichannel_stores_stock_fetched: false,
    sp_limit: 0,
    showLoginAsGuest: false,
    cartIdGuestCheckout: null,
    userAsGuestACheckout: false,
    showOverlay: false,
  },
  mutations: {
    RESET_DATA_HEADER(state) {
      state.list_wishlist = [];
      state.first_fetched = {
        wishlist: false,
        special_price: false,
      };
      state.processing = {
        wishlist: false,
        special_price: false,
      };
      state.skip = {
        wishlist: 0,
        special_price: 0,
      };
      state.limit = {
        wishlist: 5,
        special_price: 5,
      };
    },
    SET_PROCESSING_ACTION_IN_CART(state, value) {
      (state.mini_cart || []).forEach((cart, indexCart) => {
        state.mini_cart[indexCart].isProcessingAction = value;
      });
    },
    SET_OVERLAY(state, { key, value }) {
      state[key] = value;
    },
    SET_PRODUCT_CARTS_OOS(state, data) {
      state.product_carts_oos = data || [];
    },
    SET_OPEN_METHOD(state, data) {
      state.open_method = data;
    },
    REMOVE_HISTORY(state, key) {
      state.recentlySearch.splice(key, 1);
    },
    CLEAR_HISTORY(state) {
      state.recentlySearch = '';
    },
    SET_RECENTLY_SEARCH(state, data) {
      state.recentlySearch = data;
    },
    SET_RECENTLY_SEARCH_FETCHED(state, data) {
      state.recentlySearchFetched = data;
    },
    SET_ID_HISTORY(state, data) {
      state.id_history = data;
    },
    SET_ID_FEEDBACK(state, data) {
      state.id_feedback = data;
    },
    SET_ISSUBMITFEEDBACK(state, data) {
      state.isSubmitFeedback = data;
    },
    SET_TOTAL_PAYMENT_CONFIRMATION(state, value) {
      state.stickyMobileData.totalPaymentConfirmation = value;
    },
    SET_PROFILE(state, data) {
      state.stickyMobileData.profile = data;
    },
    SET_WISHLIST(state, data) {
      state.stickyMobileData.wishlists = data;
    },
    SET_MENU_STICKY_MOBILE(state, data) {
      state.stickyMobileData.menuStickyMobileActive = data;
    },
    SET_LIST_CATEGORY_MOBILE(state, data) {
      state.stickyMobileData.listCategoryMobile = data;
    },
    SET_TAB_CATEGORY_ACTIVE(state, data) {
      state.stickyMobileData.tabCategoryActive = data;
    },
    setModalSuccess(state, data) {
      state.modalSuccess = data;
    },
    applied_voucher_free_shipping(state, value) {
      state.dataOrder.applied_voucher_free_shipping = value;
    },
    resetAllState(state) {
      state.current_menu = [];
      // if (state.cartIdGuestCheckout) {
      //   state.cart_fetched = true;
      //   state.cart_data_fetched = true;
      //   state.cart_processing = true;
      //   state.cart_qty = Number(localStorage.getItem('guest_cart_total'));
      //   state.mini_cart = Array.isArray(JSON.parse(localStorage.getItem('guest_cart'))) && JSON.parse(localStorage.getItem('guest_cart')).length ? JSON.parse(localStorage.getItem('guest_cart')) : [];
      // } else {
      state.cart_fetched = false;
      state.cart_data_fetched = false;
      state.cart_processing = false;
      state.mini_cart = [];
      state.cart_qty = 0;
      //}
      state.cart_updating = false;
      state.cart_adding = false;
      state.show_search_form = false;
      state.isShowPopupUser = false;

      state.redeem_beauty_points = '';
      state.redeem_voucher = '';
      state.order_nav_current = '';

      state.cart_price_total = { cart: 0, discount: 0, delivery: 0 };
    },
    togglePopupUser(state, value) {
      state.isShowPopupUser = value;
    },
    cart_error(state, data) {
      state.cart_error = data;
    },
    cart_fetched(state) {
      state.cart_fetched = true;
    },
    cart_data_fetched(state) {
      state.cart_data_fetched = true;
    },
    cart_processing(state, value) {
      state.cart_processing = value;
    },
    cart_qty(state, value = 0) {
      state.cart_qty = value;
    },
    cart_id(state, value) {
      state.cart_id = value;
    },
    recentBroughts(state, value) {
      state.recentBroughts = value || [];
    },
    department_menu(state, data) {
      state.department_menu = data;
    },
    department_menu_raw(state, data) {
      state.department_menu_raw = data;
    },
    brands_menu(state, data) {
      state.brands_menu = data;
    },
    brands_menu_by_alphabet(state, data) {
      state.brands_menu_by_alphabet = data;
    },
    brands_country(state, data) {
      state.brands_country = data;
    },
    brands_country_by_alphabet(state, data) {
      state.brands_country_by_alphabet = data;
    },
    current_menu(state, data) {
      state.current_menu = data;
    },
    showGwp(state, data) {
      state.showGwp = data;
    },
    invalid_voucher_message(state, data) {
      state.invalid_voucher_message = data;
    },
    gwpText(state, data) {
      state.gwpText = data;
    },
    loadingCart(state, data) {
      state.loadingCart = data;
    },
    dataOrder(state, data) {
      state.dataOrder = data;
    },
    mini_cart(state, data) {
      if (Array.isArray(data)) {
        data.forEach((cart) => {
          cart.isProcessingAction = false;
        });
        state.mini_cart = data;
      } else {
        data.isProcessingAction = false;
        state.mini_cart.unshift(data);
      }
    },
    detailVoucher(state, data) {
      state.detailVoucher = data;
    },
    freeShipping(state, data) {
      state.freeShipping = data;
    },
    isFreeShipping(state, data) {
      state.isFreeShipping = data;
    },
    statusCart(state, data) {
      state.statusCart = data;
    },
    modalNotify(state, data) {
      state.modalNotify = data;
    },
    modalCartConfirm(state, data) {
      state.modalCartConfirm = data;
    },
    socoPoint(state, data) {
      state.socoPoint = data;
    },
    addCartType(state, data) {
      state.addCartType = data;
    },
    modalSocoPoints(state, data) {
      state.modalSocoPoints = data;
    },
    modalPackNotif(state, data) {
      state.modalPackNotif = data;
    },
    modalSuccess(state, data) {
      state.modalSuccess = data;
    },
    cart_updating(state, data) {
      state.cart_updating = data;
    },
    cart_adding(state, data) {
      state.cart_adding = data;
    },
    show_search_form(state, data) {
      state.show_search_form = data;
    },
    redeem_beauty_points(state, data) {
      state.redeem_beauty_points = data;
    },
    redeem_voucher(state, data) {
      state.redeem_voucher = data;
    },
    voucher_code(state, data) {
      state.voucher_code = data ? data.replace(/\s+/g, '') : '';
    },
    cart_price_total(state, data) {
      state.cart_price_total = data;
    },
    order_nav(state, data) {
      state.order_nav = data;
    },
    order_nav_current(state, data) {
      state.order_nav_current = data;
    },
    RESET_CART(state) {
      state.current_menu = [];
      state.mini_cart = [];
      state.cart_qty = 0;
      state.cart_updating = false;
      state.cart_adding = false;
      state.cart_price_total = { cart: 0, discount: 0, delivery: 0 };
      state.show_search_form = false;
      state.redeem_beauty_points = '';
      state.redeem_voucher = '';
      state.order_nav = [];
      state.order_nav_current = '';
    },
    EMERGENCIES(state, data) {
      state.emergencies = data;
    },
    BANNER_TEASER(state, data) {
      state.banner_teaser = data;
    },
    BANNER_FLOATING(state, data) {
      state.banner_floating = data;
    },
    load_recently_bought(state, data) {
      state.load_recently_bought = data;
    },
    CAMPAIGN_STATUS(state, data) {
      state.campaignStatus = data;
    },
    LIST_CAMPAIGN_BANNER(state, data) {
      state.list_campaign_banner = data;
    },
    LIST_WISHLIST(state, { data, merge = false }) {
      if (merge) {
        state.list_wishlist = state.list_wishlist.concat(data);
      } else {
        state.list_wishlist = data;
      }
    },
    SET_VOUCHER_PAPERBAG(state, data) {
      const finalVoucher = Array.isArray(data) ? data : [];

      state.voucherPaperBag = finalVoucher
        .filter((item) => item.is_special_paper_bag)
        .map((item) => {
          return {
            ...item,
            disabled: false,
            selected: (state.mini_cart || []).some((cart) => (cart.raw && cart.raw.id) == item.id),
          };
        });
    },
    SET_VOUCHER_PAPERBAG_SELECTED(state, idx) {
      state.voucherPaperBag = state.voucherPaperBag.map((item, itemIdx) => {
        if (itemIdx === idx) {
          item['selected'] = !item['selected'];
        }

        return item;
      });
    },
    TOGGLE_VOUCHER_PAPERBAG_DISABLED(state, value) {
      state.voucherPaperBag = state.voucherPaperBag.map((item) => {
        item['disabled'] = value;

        return item;
      });
    },
    LIST_PEOPLE_ALSO_BUY(state, data) {
      state.list_people_also_buy = data;
    },
    SET_PAGE_INFO(state, data) {
      state.page_info_to = data.to;
      state.page_info_title = data.title;
    },
    setBpomBanner(state, data) {
      state.bpomBanner = data;
    },
    PROMO_TEXT(state, data) {
      state.promo_text = data;
    },
    MAIN_BANNER(state, data) {
      state.main_banner = data;
    },
    BRAND_LAUNCH(state, data) {
      state.brand_launch = data;
    },
    DAILY_DEALS(state, data) {
      state.daily_deals = data;
    },
    DAILY_DEALS_TITLE(state, data) {
      state.daily_deals_title = data;
    },
    FLASH_SALE_THEME(state, data) {
      state.flash_sale_theme = data;
    },
    FLEXIBLE_BANNER(state, data) {
      state.flexible_banner = data;
    },
    LOADING_BANNER(state, data) {
      state.loading_banner = data;
    },
    INTERSECTION(state, { section, value }) {
      if (section) {
        state.intersection[section] = value;
      }
    },
    LOADING_INTERSECTION(state, { section, value }) {
      if (section) {
        state.loading_intersection[section] = value;
      }
    },
    FEATURED_BRAND_TITLE(state, data) {
      state.featured_brand_title = data;
    },
    FLOATING_ICON_APPS(state, data) {
      state.floating_icon_apps = data || [];
    },
    SOCIOLLA_LOGO_THEMATIC(state, data) {
      state.sociolla_logo_thematic = data;
    },
    SET_QUICK_TOUR_STATE(state, data) {
      state.quick_tour_state = data;
      if (data) {
        const index = state.quick_tour_visited.indexOf(data);
        if (index < 0) {
          state.quick_tour_visited.push(data);
        }
      } else {
        state.quick_tour_visited = [];
      }
    },
    SET_DATA_PURCHASE_MULTIPLE(state, data) {
      state.data_purchase_multiple = data;
    },
    SEARCHBAR_PROMO_TEXT(state, data) {
      state.searchbar_promo_text = data || [];
    },
    TITLE_FLEXIBLE_BANNER(state, data) {
      state.title_flexible_banner = data || [];
    },
    SET_LOADING_SPECIAL_PRICE(state, value) {
      state.loadingSpecialPrice = value;
    },
    SET_BANNER_CALLED(state, data) {
      state.banner_called = data;
    },
    SET_POPUP_BANNER_CLOSED(state, data) {
      state.popup_banner_closed = data;
    },
    SHOW_STICKY_FREE_SHIPPING_INFO(state, data) {
      state.show_sticky_free_shipping = data;
    },
    setUserVoucherCode(state, data) {
      state.voucherCode = data;
    },
    setTours(state, data) {
      state.tours = data;
    },
    IS_CATEGORY_LOADING(state, value) {
      state.is_category_loading = value;
    },
    SET_OMNICHANNEL_DATA(state, data) {
      state.omnichannel_data = { ...state.omnichannel_data, ...data };
    },
    SET_OMNICHANNEL_DATA_SESSION(state, data) {
      state.omnichannel_data_session = data;
    },
    CHANGE_OMNICHANNEL_METHODS(state, data) {
      state.change_omnichannel = data;
    },
    SET_OMNICHANNEL_TOUR_DATA(state, { section, data }) {
      if (section) {
        state.set_omnichannel_tours[section] = data;
      }
    },
    set_omnichannel_stores_stock(state, data) {
      state.omnichannel_stores_stock = data;
    },
    set_omnichannel_stores_stock_loading(state, data) {
      state.omnichannel_stores_stock_loading = data;
    },
    set_omnichannel_stores_stock_fetched(state, data) {
      state.omnichannel_stores_stock_fetched = data;
    },
    SET_SP_LIMIT(state, data) {
      state.sp_limit = data;
    },
    setToShowLoginAsGuest(state, data) {
      state.showLoginAsGuest = data;
    },
    setUserAsGuestACheckout(state, data) {
      state.userAsGuestACheckout = data;
    },
    setCartIdGuestCheckout(state, data) {
      state.cartIdGuestCheckout = data;
    },
  },
  actions: {
    async doCheckIsQuickTourEnabled({ state, commit }, quickTourState) {
      // try {
      //     const response = await axios.get(`${Config.MS_SOCO_PUBLIC_API_URL}/feature-toggles/sociolla_quick_tour`);
      //     state.isQuickTourEnabled = (response.data && response.data.data);
      // } catch (e) {
      //     console.log(e);
      // }

      // const isEnabled = state.isQuickTourEnabled || false;

      // if (quickTourState && isEnabled) {
      //     commit('SET_QUICK_TOUR_STATE', quickTourState);
      // }

      // return isEnabled;
      return false;
    },
    setOverlay({ commit }, value) {
      commit('SET_OVERLAY', { key: 'showOverlay', value });
    },
    removeHistory({ commit, dispatch }, { key, history }) {
      return axios
        .delete(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-keywords/${history['_id']}`)
        .then((response) => {
          if (response.status === 200) {
            commit('REMOVE_HISTORY', key);
            dispatch('fetchRecentlySearch');
            commit('SET_RECENTLY_SEARCH_FETCHED', false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkOutOfStockProducts({ commit }, productIds) {
      if (productIds && productIds.length) {
        const params = {
          skip: 0,
          limit: productIds.length,
          filter: { id: { $in: productIds } },
          fields: 'is_out_of_stock_sociolla,id',
        };

        return axios
          .get(`${Config.MS_CATALOG_API_URL}/v3/products`, { params })
          .then((response) => {
            commit('SET_PRODUCT_CARTS_OOS', response && response.data && response.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    clearHistory({ commit }) {
      return axios
        .delete(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-keywords-clear`)
        .then((response) => {
          if (response.status === 200) {
            commit('CLEAR_HISTORY');
            commit('SET_RECENTLY_SEARCH_FETCHED', false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    savedSearchHistory({ commit }, { entity_id, keyword, entity_type = 'product' }) {
      const params = {
        entity_id: entity_id, // id product
        keyword: keyword, // keyword yg dimasukin
        entity_type: entity_type,
      };
      return axios
        .post(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-clicks`, params)
        .then((response) => {
          if (response.status === 200) {
            commit('SET_ID_HISTORY', response.data.data._id);
          } else {
            commit('SET_ID_HISTORY', '');
          }
          commit('SET_ID_FEEDBACK', '');
          commit('SET_ISSUBMITFEEDBACK', false);
          return response;
        })
        .catch((err) => {
          commit('SET_ID_HISTORY', '');
          commit('SET_ID_FEEDBACK', '');
          commit('SET_ISSUBMITFEEDBACK', false);
          return err;
        });
    },
    sendFeedback({ commit, state }, { feedback }) {
      const params = {
        feedback: feedback, // feedback
        search_history_clicks_id: state.id_history, // id history search
      };
      return axios
        .post(`${Config.MS_SOCO_PUBLIC_API_URL}/search/feedbacks`, params)
        .then((response) => {
          if (response.status === 200) {
            commit('SET_ID_FEEDBACK', response.data.data._id);
            if (feedback === 'good') {
              commit('SET_ISSUBMITFEEDBACK', true);
            }
          } else {
            commit('SET_ID_FEEDBACK', '');
          }
          return response;
        })
        .catch((err) => {
          commit('SET_ID_FEEDBACK', '');
          return err;
        });
    },
    putFeedback({ state, commit }, { payload, id }) {
      return axios.put(`${Config.MS_SOCO_PUBLIC_API_URL}/search/${id}/feedbacks`, payload);
    },
    fetchRecentlySearch({ commit }) {
      return axios
        .get(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-keywords`, {
          params: {
            limit: 5,
            filter: {
              source_from: 'sociolla',
            },
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const arr = [];
            const data = response.data.data;
            for (let i = 0; i < data.length; i++) {
              if (!arr.includes(data[i]['keyword'])) {
                arr.push(data[i]['keyword']);
              } else {
                data.splice(i, 1);
                i--;
              }
            }
            commit('SET_RECENTLY_SEARCH', data);
            commit('SET_RECENTLY_SEARCH_FETCHED', true);
          } else {
            commit('SET_RECENTLY_SEARCH', []);
            commit('SET_RECENTLY_SEARCH_FETCHED', true);
          }
          return response;
        })
        .catch((err) => {
          commit('SET_RECENTLY_SEARCH', []);
          commit('SET_RECENTLY_SEARCH_FETCHED', false);
          return err;
        });
    },
    fetchAllBadges() {
      return axios.get(Config.MS_SOCO_PUBLIC_API_URL + `/rewards`, {
        params: {
          filter: {
            'point.point_type': 'badges',
            reward_name: 'bagdes',
          },
          limit: 100,
        },
      });
    },
    fetchTotalPaymentConfirmation({ commit }, payload) {
      return axios
        .get(`${Config.MS_ORDER_API_URL}/user/me/orders/count`, {
          params: {
            skip: 0,
            limit: 10,
            filter: { 'state.name': 'Awaiting bank wire payment' },
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit('SET_TOTAL_PAYMENT_CONFIRMATION', response.data.data);
          } else {
            commit('SET_TOTAL_PAYMENT_CONFIRMATION', 0);
          }
        })
        .catch((err) => {
          commit('SET_TOTAL_PAYMENT_CONFIRMATION', 0);
        });
    },
    fetchProfile({ commit, rootState, dispatch }, payload) {
      return Q.try(function () {
        return axios.get(Config.MS_SOCO_PUBLIC_API_URL + '/user/me');
      })
        .then((response) => {
          if (response.data.success) {
            if (rootState.$_Auth.user.user_name) {
              return axios
                .get(Config.MS_SOCO_PUBLIC_API_URL + '/profile', {
                  params: {
                    filter: {
                      user_name: `${rootState.$_Auth.user.user_name}`,
                    },
                  },
                })
                .then(function (response) {
                  if (response.status === 200) {
                    commit('SET_PROFILE', response.data.data);
                  } else {
                    commit('SET_PROFILE', {});
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  commit('SET_PROFILE', {});
                });
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    modalNotify({ commit, state, dispatch }, data) {
      commit('modalNotify', data);
      if (data) {
        document.documentElement.classList.add('noscroll');
      } else {
        document.documentElement.classList.remove('noscroll');
      }
    },
    modalPackNotif({ commit, state, dispatch }, data) {
      commit('modalPackNotif', data);
      if (data) {
        document.documentElement.classList.add('noscroll');
      } else {
        document.documentElement.classList.remove('noscroll');
      }
    },
    modalSuccess({ commit, state, dispatch }, data) {
      commit('modalSuccess', data);
      if (data) {
        document.documentElement.classList.add('noscroll');
      } else {
        document.documentElement.classList.remove('noscroll');
      }
    },
    modalSocoPoints({ commit, state, dispatch }, data) {
      commit('modalSocoPoints', data);
      if (data) {
        document.documentElement.classList.add('noscroll');
      } else {
        document.documentElement.classList.remove('noscroll');
      }
    },
    getDepartmentMenu({ commit, state, dispatch }, el) {
      commit('IS_CATEGORY_LOADING', true);
      // el.$axios
      //   .get(el.$customConfig.API.departmentMenu, {
      //     params: {
      //       filter: {
      //         name: 'Shop By Departments',
      //         depth: 3,
      //       },
      //       fields: 'name,my_sociolla_sql_id,link_rewrite,parents,slug,banner_for_sociolla,logo',
      //       skip: 0,
      //       limit: 30,
      //       sort: 'position',
      //     },
      //   })
      //   .then((response) => {
      //     const list = {};
      //     let copyWithValueDepartmentMenu;
      //     const categories = [];
      //     if (response.status == 200 && response.data.data) {
      //       // let menu = response.data.data.children.map(res => {
      //       //     res.selected = ''
      //       //     res.level = 1
      //       //     res.children.map(res2 => {
      //       //         res2.selected = ''
      //       //         res2.level = 2
      //       //         res2.children.map(res3 => {
      //       //             res3.selected = ''
      //       //             res3.level = 3
      //       //         })
      //       //     })
      //       //     return res
      //       // })
      //       response.data.data.children.forEach((category, key) => {
      //         if (response.data.data.children[key].slug) {
      //           categories.push(category);
      //         }
      //       }) || [];

      //       copyWithValueDepartmentMenu = response.data.data.children
      //         ? JSON.parse(JSON.stringify(response.data.data.children))
      //         : {};

      //       if (copyWithValueDepartmentMenu && Object.keys(copyWithValueDepartmentMenu).length) {
      //         copyWithValueDepartmentMenu.forEach((department, keyDepartment) => {
      //           list[department['_id']] = [];
      //           if (department.children && department.children.length) {
      //             department.children.forEach((category, keyCategory) => {
      //               category.departmentName = department.name;
      //               category.departmentSlug = department.slug;
      //               list[department['_id']].push(category);
      //               category.children.forEach((subcategory, keySubcategory) => {
      //                 list[department['_id']].push(subcategory);
      //               });
      //             });
      //           }
      //         });
      //       }

      //       if (categories && categories[0]) {
      //         commit('SET_TAB_CATEGORY_ACTIVE', categories[0]['_id']);
      //       }
      //       commit('SET_LIST_CATEGORY_MOBILE', list);
      //       commit('department_menu', categories);
      //       commit('IS_CATEGORY_LOADING', false);
      //       /*let temp = []
      //                   let data = response.data.data
      //                   for (let i in data) {
      //                       temp.push({id_category: data[i].id_category, link_rewrite: data[i].link_rewrite, name: data[i].name, id_parent: ''})
      //                       if (data[i].children != undefined && data[i].children.length) {
      //                           let child = data[i].children
      //                           for (let j in child) {
      //                               temp.push({id_category: child[j].id_category, link_rewrite: child[j].link_rewrite, name: child[j].name, id_parent: child[j].id_parent})
      //                               if (child[j].children != undefined && child[j].children.length) {
      //                                   let sub = child[j].children
      //                                   for (let k in sub) {
      //                                       temp.push({id_category: sub[k].id_category, link_rewrite: sub[k].link_rewrite, name: sub[k].name, id_parent: sub[k].id_parent})
      //                                   }
      //                               }
      //                           }
      //                       }
      //                   }
      //                   commit('department_menu_raw', temp)*/
      //     }
      //   })
      //   .catch((error) => {
      //     commit('IS_CATEGORY_LOADING', false);
      //     console.log(error);
      //   });
    },
    getBrandsMenu({ commit, state, dispatch }, data) {
      const params = {
        fields: 'name,logo,slug',
        limit: 100,
        sort: 'name',
      };

      data.$axios
        .get(data.$customConfig.API.brandsLetter, { params })
        .then((response) => {
          if (response.status === 200) {
            const brandsMenu = Object.keys(response.data.data || {}).reduce((accu, key) => {
              response.data.data[key].forEach((brand) => {
                const { _id: id_manufacturer } = brand;

                accu.push(Object.assign({ id_manufacturer }, brand));
              });

              return accu;
            }, []);

            commit('brands_menu', brandsMenu);
            commit('brands_menu_by_alphabet', response.data.data || {});

            if (data.$route.name === 'Manufacture') {
              dispatch('setSidebarBrandTitle', this._vm);
            }

            if (brandsMenu.length) {
              const sortedBrand = brandsMenu
                .filter((b) => b.country)
                .sort(function (a, b) {
                  const nameA = a.country.toUpperCase();
                  const nameB = b.country.toUpperCase();
                  if (nameA < nameB) {
                    return -1;
                  }
                  if (nameA > nameB) {
                    return 1;
                  }
                  return 0;
                });
              const country = {};
              sortedBrand.forEach((brand) => {
                if (!country[brand.country] && brand.country) {
                  country[brand.country] = brand;
                }
              });
              const isAlphabet = (char) => char.match(/^[A-Za-z]+$/);
              const letters = {
                '#': [],
                A: [],
                B: [],
                C: [],
                D: [],
                E: [],
                F: [],
                G: [],
                H: [],
                I: [],
                J: [],
                K: [],
                L: [],
                M: [],
                N: [],
                O: [],
                P: [],
                Q: [],
                R: [],
                S: [],
                T: [],
                U: [],
                V: [],
                W: [],
                X: [],
                Y: [],
                Z: [],
              };
              for (const [key, value] of Object.entries(country)) {
                const firstChar = key[0] == ' ' ? key.replace(' ', '')[0].toUpperCase() : key[0].toUpperCase();
                const isAlpha = isAlphabet(firstChar);
                if (isAlpha) {
                  letters[firstChar].push(value);
                } else {
                  letters['#'].push(value);
                }
              }
              dispatch('getBrandsOrigin', { data, letters });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getBrandsOrigin({ commit, state, dispatch }, { data, letters }) {
      if (letters && Object.entries(letters).length) {
        const brandsMenu = Object.keys(letters).reduce((accu, key) => {
          letters[key].forEach((brand) => {
            const { _id: id_manufacturer } = brand;
            accu.push(
              Object.assign(
                {
                  id_manufacturer,
                  country_slug:
                    (brand.country_tag_id || '') + '_' + 'cn-origin-' + brand.country.toLowerCase().replace(' ', '-'),
                },
                brand
              )
            );
          });

          return accu;
        }, []);

        commit('brands_country', brandsMenu);
        commit('brands_country_by_alphabet', letters || {});
      } else {
        const params = {
          fields: 'name,logo,slug,origins.country,origins.flag',
          limit: 100,
          sort: 'origins.country',
          filter: { group_by_country: true },
        };

        data.$axios
          .get(data.$customConfig.API.brandsLetter, { params })
          .then((response) => {
            if (response.status === 200) {
              const brandsMenu = Object.keys(response.data.data || {}).reduce((accu, key) => {
                response.data.data[key].forEach((brand) => {
                  const { _id: id_manufacturer } = brand;
                  accu.push(
                    Object.assign(
                      {
                        id_manufacturer,
                        country_slug:
                          (brand.country_tag_id || '') +
                          '_' +
                          'cn-origin-' +
                          brand.country.toLowerCase().replace(' ', '-'),
                      },
                      brand
                    )
                  );
                });

                return accu;
              }, []);

              commit('brands_country', brandsMenu);
              commit('brands_country_by_alphabet', response.data.data || {});
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    fetchCurrentUserQtyCart({ state, commit, getters }, context) {
      return axios.get(`${Config.MS_CART_API_URL}/user/me/carts/count`).then((response) => {
        const count = (response.data && response.data.data) || 0;
        commit('cart_qty', count);
        if (state.userAsGuestACheckout) {
          localStorage.setItem('guest_cart_total', count);
        }

        // mark already fetched if total eq 0
        if (count === 0) {
          commit('cart_fetched');
          commit('cart_processing', false);
        }

        return response;
      });
    },
    fetchCurrentUserCart({ commit, state, dispatch, getters, rootState }, payload) {
      commit('cart_error', false);
      if (!rootState.$_Auth.loggedIn && !state.userAsGuestACheckout) {
        dispatch('updateCartPriceTotal', { cart: getters.cart_price });
        commit('dataOrder', { total_amount: state.cart_price_total.cart });
        return;
      }

      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();

      let params = {
        timestamp: new Date(),
        filter: {
          is_payment_method_change: payload && payload.is_payment_method_change ? true : false,
        },
      };
      if (state.userAsGuestACheckout && state.cartIdGuestCheckout) {
        params = {
          filter: {
            id: state.cartIdGuestCheckout,
          },
        };
      } else {
        if (payload && payload.is_payment_method_change) {
          params.filter.cart_id = payload.cart_id;
        }
      }
      return axios
        .get(`${this._vm.$customConfig.API.userMe}/carts`, {
          cancelToken: source.token,
          params: params,
        })
        .then(async (response) => {
          commit('cart_data_fetched');
          if (response.status == 200 && '_id' in response.data.data) {
            commit('cart_id', response.data.data._id);
            const order_data = response.data.data;
            const free_product = [];
            const normal_product = [];
            if (state.userAsGuestACheckout && !order_data.products.length) {
              commit('loadingCart', false);
              localStorage.removeItem('guest_checkout_cart_id');
              localStorage.removeItem('guest_cart');
              localStorage.removeItem('guest_cart_total');
              router.push('/');
              return;
            }
            this._vm.$get(order_data, 'products', []).map((item) => {
              if (item.is_applied_free_product) {
                item.image = item.detail.image;
                const { _id, id, quantity: qty, combination_id } = item;
                const product = Object.assign({}, item);
                const brand = this._vm.$get(item, 'detail.brand', {});
                const name = this._vm.$get(item, 'detail.name', '');

                free_product.push({ _id, id, combination_id, brand, product, qty, name });
              } else {
                const { _id, id, quantity: qty, combination_id } = item;
                const raw = Object.assign({}, item);
                const brand = this._vm.$get(item, 'detail.brand.name', '');
                const name = this._vm.$get(item, 'detail.name', '');

                normal_product.push({ _id, id, combination_id, brand, raw, qty, name });
              }
            });
            order_data.free_products = order_data.free_products.concat(free_product);
            order_data.products = normal_product;
            commit('dataOrder', order_data);

            let gwp_message = '';

            if (Array.isArray(order_data.gwp_error_message)) {
              if (order_data.gwp_error_message.length) {
                gwp_message = order_data.gwp_error_message[0];
              }
            } else {
              gwp_message = order_data.gwp_error_message;
            }

            if (gwp_message) {
              commit('showGwp', true);
              commit('gwpText', gwp_message);
            } else {
              commit('showGwp', false);
              commit('gwpText', '');
            }

            if (order_data.point_applied && !state.userAsGuestACheckout) {
              commit('redeem_beauty_points', order_data.point_applied);
              dispatch('updateCartPriceTotal', { discount: 1 });
            } else if (order_data.voucher_id) {
              commit('voucher_code', order_data.voucher_code);
              commit('redeem_voucher', order_data.voucher_id);
              dispatch('updateCartPriceTotal', { discount: 1 });
            } else {
              if (state.redeem_beauty_points) {
                commit('redeem_beauty_points', '');
              } else {
                commit('redeem_voucher', '');
                commit('voucher_code', '');
              }
              dispatch('updateCartPriceTotal', { discount: 0 });
            }

            await commit('mini_cart', normal_product);
            commit(
              'cart_qty',
              state.mini_cart.reduce((sum, cur) => sum + Number(cur.qty), 0)
            );
            if (state.userAsGuestACheckout) {
              await localStorage.setItem('guest_cart', JSON.stringify(normal_product));
              localStorage.setItem(
                'guest_cart_total',
                state.mini_cart.reduce((sum, cur) => sum + Number(cur.qty), 0)
              );
            }
            if (normal_product.length) {
              commit('loadingCart', false);
            } else {
              setTimeout(() => {
                commit('loadingCart', false);
              }, 500);
            }
            if (order_data.has_oos_product) {
              this._vm.$toasted.global.error('Beberapa stock produk tidak cukup');
            }

            if (payload && payload.isOrderPage) {
              return normal_product;
            }

            return true;
          } else {
            commit('loadingCart', false);
            return;
          }
        })
        .catch((error) => {
          commit('cart_data_fetched');
          commit('loadingCart', false);
          if (payload && payload.isOrderPage) {
            commit('cart_error', true);
          }
          console.log(error);
          return;
        })
        .finally(() => {
          if (state.voucherPaperBag && state.voucherPaperBag.length) {
            commit('SET_VOUCHER_PAPERBAG', state.voucherPaperBag);
          }
        });
    },
    fetchUsedPointPerDay({ commit }) {
      return axios
        .get(`${Config.MS_CART_API_URL}/points/limit`)
        .then((res) => {
          const { data: left_sp } = res.data;
          commit('SET_SP_LIMIT', left_sp);
        })
        .catch(() => {
          commit('SET_SP_LIMIT', 0);
        });
    },
    addToCart({ commit, state, dispatch, getters, rootState }, data) {
      const reference = {
        verb: 'add',
        location_id: data.$route.params ? data.$route.params.categoryId : undefined,
        location_type: data.$route.name === 'SingleProduct' ? 'product detail page' : '',
        slug: data.$route.params ? data.$route.params.categorySlug : undefined,
      };

      const payload = { ...data.dataCart, reference };
      if (state.cart_id) {
        payload.id = state.cart_id;
      }
      if (rootState.isSelfCheckoutId) {
        payload.store_id = rootState.isSelfCheckoutId;
        payload.source = 'sociolla_store';
      }
      commit('statusCart', true);
      const loadingModal = rootState.$_Modal.addToBag.isLoading;
      return data.$axios
        .post(`${data.$customConfig.API.userMe}/carts`, payload)
        .then((res) => {
          try {
            if (state.modalCartConfirm) {
              state.modalCartConfirm = false;
            }
          } catch (e) {}
          if (loadingModal) {
            commit('$_Modal/TOGGLE_LOADING', 'addToBag', { root: true });
          }
          data.loadingBag = false;
          if (res.status == 200) {
            commit('cart_id', res.data.data._id);
            dispatch('setMiniCart', data);

            // if(data.isEgift) {
            //     data.product.egift_info = data.egift_info
            //     data.product.eGiftCombination = data.eGiftCombination
            // }

            const cart_type = state.addCartType;
            if (cart_type != 'buy') {
              commit(
                '$_Modal/SET_NOTIFICATION_ADD_CART_DATA',
                { ...data.product, active_combination: data.activeCombination },
                { root: true }
              );
              commit('$_Modal/SET_NOTIFICATION_ADD_CART_COMBINATION_GROUP_NAME', data.dataModalCart.attribute_html, {
                root: true,
              });
              commit('$_Modal/SHOW', 'notificationAddCart', { root: true });
            }
            if (cart_type == 'buy') {
              commit('addCartType', '');
              // commit("$_Modal/HIDE", "notificationAddCart", {root: true});
              // commit("$_Modal/SET_NOTIFICATION_ADD_CART_DATA", null, {root: true});
              // commit('$_Modal/SET_NOTIFICATION_ADD_CART_COMBINATION_GROUP_NAME', null, {root: true})
              data.$router.push('/order');
            } else if (cart_type != 'buy' && !data.isEgift) {
              setTimeout(() => {
                // commit("$_Modal/HIDE", "notificationAddCart", {root: true});
                // commit("$_Modal/SET_NOTIFICATION_ADD_CART_DATA", null, {root: true});
                // commit('$_Modal/SET_NOTIFICATION_ADD_CART_COMBINATION_GROUP_NAME', null, {root: true})
              }, 3000);
            }

            // dispatch('fetchCurrentUserQtyCart')

            try {
              dispatch(
                '$_InternalTracking/setEvent',
                {
                  verb: 'add',
                  object_id: res.data.data ? res.data.data._id : '',
                  object_type: 'cart',
                  referrer: {
                    // url:document.referrer ? document.referrer : (rootState.historyUrl.from != '/' ? `${rootState.SOCIOLLA_WEB_URL}${rootState.historyUrl.from}` : ''),
                    id: res.data.data ? res.data.data._id : '',
                    object_type: data.info.type,
                  },
                  additional: {
                    target: {
                      id: data.dataCart.product.id,
                      object_type: 'product',
                      combination_id: data.dataCart.product.combination_id,
                    },
                  },
                },
                { root: true }
              );
            } catch (err) {
              console.log(err);
            }

            return true;
          }
          commit('statusCart', false);
        })
        .catch((err) => {
          data.loadingBag = false;
          if (loadingModal) {
            commit('$_Modal/TOGGLE_LOADING', 'addToBag', { root: true });
          }
          console.log(err);
          data.$toasted.global.error(err.response.data.message);
          commit('statusCart', false);
          commit('addCartType', '');
        });
    },
    addToCartNoLogin({ commit, state, dispatch, getters }, data) {
      commit('statusCart', true);
      let combination = '';
      let product = {};
      let productCart = {};

      if (data.combination_name) {
        combination = data.combination_name;
      } else {
        if (data.dataModalCart) {
          combination = data.dataModalCart.attribute_html;
        }
      }

      if (data.product.detail) {
        product = data.product.detail;
      } else {
        product = data.product;
      }

      data.nologin = true;

      let hasEgift = false;
      let preorderSameDate = true;
      let datePreorder = null;
      // let hasPreOrder = false;
      if (data.isEgift) {
        // commit('$_Modal/TOGGLE_LOADING', 'addToBag', {root: true})
      }

      if (data.activeCombination) {
        productCart = data.activeCombination;
      } else {
        productCart = data.combination;
      }

      if (productCart.is_pre_order) {
        data = { ...data, isPreOrder: true, product };
        datePreorder = productCart.delivery_date;
      }
      state.mini_cart.forEach((x) => {
        if (x.raw.egift_info && x.raw.egift_info.delivery_date) {
          hasEgift = true;
        }
        if (x.raw.is_pre_order && datePreorder) {
          // hasPreOrder = true;
          preorderSameDate = dayjs(x.raw.delivery_date).isSame(dayjs(datePreorder));
        }
      });
      if (!data.isEgift && hasEgift) {
        data.loadingBag = false;
        commit('statusCart', false);
        data.$toasted.global.error('Produk E Gift Card tidak dapat digabung dengan produk lainnya');
      } else if (productCart.is_pre_order && !preorderSameDate) {
        data.loadingBag = false;
        commit('statusCart', false);
        this._vm.$toasted.global.error('Product with different delivery date cannot be bought for preorder products');
      } else {
        dispatch('setMiniCart', data);

        if (state.addCartType != 'buy') {
          commit(
            '$_Modal/SET_NOTIFICATION_ADD_CART_DATA',
            { ...product, active_combination: productCart },
            { root: true }
          );
          if (combination) {
            commit('$_Modal/SET_NOTIFICATION_ADD_CART_COMBINATION_GROUP_NAME', combination, { root: true });
          }
          commit('$_Modal/SHOW', 'notificationAddCart', { root: true });
        }
        data.loadingBag = false;
        dispatch('updateCartPriceTotal', { cart: getters.cart_price });
        commit('dataOrder', { total_amount: state.cart_price_total.cart });

        setTimeout(() => {
          commit('statusCart', false);
        }, 1000);

        if (state.addCartType == 'buy') {
          // commit("$_Modal/HIDE", "notificationAddCart", {root: true});
          // commit("$_Modal/SET_NOTIFICATION_ADD_CART_DATA", null, {root: true});
          // if (combination) {
          //     commit('$_Modal/SET_NOTIFICATION_ADD_CART_COMBINATION_GROUP_NAME', null, {root: true})
          // }
          commit('$_Auth/setFormTypeOfAuth', 'login', { root: true });
        } else {
          setTimeout(() => {
            // commit("$_Modal/HIDE", "notificationAddCart", {root: true});
            // commit("$_Modal/SET_NOTIFICATION_ADD_CART_DATA", null, {root: true});
            // if (combination) {
            //     commit('$_Modal/SET_NOTIFICATION_ADD_CART_COMBINATION_GROUP_NAME', null, {root: true})
            // }
          }, 4000);
        }
        state.cart_qty = state.mini_cart.reduce((total, currentValue) => {
          return total + currentValue.qty;
        }, 0);
      }
    },
    checkCartRule({ commit, state, dispatch, rootState }, data) {
      let productCart = {};
      // const preorderSameDate = true;
      // let datePreorder = null;
      let hasPreOrder = false;

      if (data.activeCombination) {
        productCart = data.activeCombination;
      } else {
        productCart = data.combination;
      }

      if (productCart.is_pre_order) {
        // datePreorder = productCart.delivery_date;
      }

      state.mini_cart.forEach((x) => {
        if (x.raw.egift_info && x.raw.egift_info.delivery_date) {
          hasEgift = true;
        }
        if (x.raw.is_pre_order) {
          hasPreOrder = true;
        }
      });

      if (
        (!productCart.is_pre_order && hasPreOrder) ||
        (productCart.is_pre_order && !hasPreOrder && state.mini_cart.length)
      ) {
        const dataForModal = {
          modal: {
            title: 'ATTENTION',
            confirmation:
              'Pembelian produk Pre-Order tidak dapat digabung dengan produk lainnya. Jika kamu mempunyai produk yang telah dimasukkan ke dalam shopping bag sebelumnya, maka akan otomatis terhapus.',
            is_confirm: true,
            ok_title: 'ADD TO BAG',
            cancel_title: 'CANCEL',
          },
          action: {
            onOk: function () {
              if (rootState.$_Auth.loggedIn) {
                dispatch('addToCart', data);
              } else {
                dispatch('addToCartNoLogin', data);
              }
            },
            onCancel: function () {
              commit('$_Modal/HIDE', 'global', { root: true });
              commit('$_Modal/ADD_DATA', { data: null, modalName: 'global' }, { root: true });
            },
          },
        };
        commit('$_Modal/SHOW', 'global', { root: true });
        commit('$_Modal/ADD_DATA', { data: dataForModal, modalName: 'global' }, { root: true });
        return false;
      }

      if (rootState.$_Auth.loggedIn) {
        dispatch('addToCart', data);
      } else {
        dispatch('addToCartNoLogin', data);
      }
    },
    async fetchRecentlyBrought({ commit }) {
      try {
        const response = await axios.get(ConfigApi.API.recentBought);
        const data = this._vm.$get(response, 'data.data', []);
        commit('recentBroughts', data);
        commit('load_recently_bought', false);
      } catch (e) {
        console.log(e);
        commit('load_recently_bought', false);
      }
    },
    async updateToCart({ commit, state, dispatch, getters }, data) {
      if (!('fetch_point' in data)) {
        data.fetch_point = true;
      }
      await axios
        .post(Config.MS_CART_API_URL + '/user/me/carts', data.payload)
        .then((res) => {
          if (res.status == 200) {
            commit('mini_cart', data.component.carts);
            if (state.userAsGuestACheckout) {
              localStorage.setItem('guest_cart', JSON.stringify(data.component.carts));
            }
            try {
              dispatch(
                '$_InternalTracking/setEvent',
                {
                  verb: 'add',
                  object_id: state.dataOrder._id,
                  object_type: 'cart',
                  referrer: {
                    id: state.dataOrder._id,
                    object_type: 'cart',
                  },
                  additional: {
                    target: {
                      id: data.payload.product.id,
                      object_type: 'product',
                      combination_id: data.payload.product.combination_id,
                    },
                    action: data.payload.action,
                  },
                },
                { root: true }
              );
            } catch (err) {
              console.log(err);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          data.component.$toasted.global.error(err.response.data.message);
        });

      dispatch('fetchCurrentUserCart').then((res) => {
        if (data.fetch_point && !state.userAsGuestACheckout) {
          dispatch('getUpdateSocoPoint');
        }
      });
    },
    getUpdateSocoPoint({ commit, state, dispatch, getters }) {
      if (state.dataOrder && Object.keys(state.dataOrder).length) {
        axios
          .get(this._vm.$customConfig.API.points, {
            params: {
              filter: {
                is_new_ui: true,
                total_amount: state.dataOrder.total_amount_after_discount,
              },
            },
          })
          .then((res) => {
            if (res.status === 200 && res.data.data) {
              if (res.data.data.length > 1) {
                res.data.data.sort(function (a, b) {
                  return a - b;
                });
              }
              commit('socoPoint', res.data.data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    showSearchForm({ commit, state, dispatch }, data) {
      const status = state.show_search_form ? false : true;
      commit('show_search_form', status);
    },
    redeemBeautyPoints({ commit, state, dispatch }, data) {
      if (data.beauty_point_value) {
        data.$axios
          .post(data.$customConfig.API.redeemBeautyPoints, {
            points: Number(data.beauty_point_value),
          })
          .then((response) => {
            if (response.status === 200) {
              commit('redeem_beauty_points', response.data.data);
              dispatch('updateCartPriceTotal', { discount: 1 });
              dispatch('getSpecialPrice', { data: data });

              dispatch('fetchCurrentUserCart').then((res) => {
                data.loading.voucher = false;
                dispatch('getUpdateSocoPoint');
              });
              dispatch('$_Order/getPickGwpList', { context: data, force: true }, { root: true });
              commit('invalid_voucher_message', '');

              if (data.isSelfCheckout) {
                dispatch('fetchVoucherPaperBag');
              }

              try {
                dispatch(
                  '$_InternalTracking/setEvent',
                  {
                    verb: 'apply',
                    object_id: '',
                    object_type: 'point',
                    referrer: {
                      id: '',
                      object_type: 'cart',
                    },
                    additional: {
                      target: {
                        id: state.dataOrder._id,
                        object_type: 'cart',
                      },
                      applied_points: Number(data.beauty_point_value),
                    },
                  },
                  { root: true }
                );
              } catch (err) {
                console.log(err);
              }
            } else {
              data.loading.voucher = false;
            }
          })
          .catch((error) => {
            data.$toasted.global.error(error.response.data.message);
            data.loading.voucher = false;
          });
      } else {
        data.loading.voucher = false;
      }
    },
    redeemVoucher({ commit, state, dispatch, getters }, data) {
      if (state.voucher_code) {
        const payload = {
          voucher_code: state.voucher_code,
        };
        if (state.userAsGuestACheckout && state.cartIdGuestCheckout) {
          payload.cart_id = state.cartIdGuestCheckout;
        }
        data.$axios
          .post(data.$customConfig.API.redeemVoucher, payload)
          .then((response) => {
            if (response.status === 200) {
              commit('voucher_code', state.voucher_code);
              commit('redeem_voucher', response.data.data);

              dispatch('updateCartPriceTotal', { discount: 1 });
              // SOC-49636 Reload special price list after apply voucher
              if (!state.cartIdGuestCheckout) {
                dispatch('getSpecialPrice', { data: data });
              }

              dispatch('fetchCurrentUserCart').then((res) => {
                data.loading.voucher = false;
                if (!state.userAsGuestACheckout) {
                  dispatch('getUpdateSocoPoint');
                }
              });
              if (!state.cartIdGuestCheckout) {
                dispatch('$_Order/getPickGwpList', { context: data, force: true }, { root: true });
              }

              // let message = '';
              if (state.redeem_voucher.type == 'free_shipping') {
                if (state.redeem_voucher.discount_info && state.redeem_voucher.discount_info.shipping_fee_discount) {
                  // message = `Kamu mendapatkan diskon Free Shipping max Rp
                  //                   ${data.$options.filters.currency(
                  //                     state.redeem_voucher.discount_info.shipping_fee_discount
                  //                   )}`;
                } else {
                  // message = 'Kamu mendapatkan gratis ongkir';
                }
              }
              //commit('invalid_voucher_message', message)

              if (data.isSelfCheckout) {
                dispatch('fetchVoucherPaperBag');
              }

              try {
                dispatch(
                  '$_InternalTracking/setEvent',
                  {
                    verb: 'apply',
                    object_id: response.data.data.id,
                    object_type: 'voucher',
                    referrer: {
                      id: '',
                      object_type: 'cart',
                    },
                    additional: {
                      target: {
                        id: state.dataOrder._id,
                        object_type: 'cart',
                      },
                    },
                  },
                  { root: true }
                );
              } catch (err) {
                console.log(err);
              }
            } else {
              data.loading.voucher = false;
              commit('voucher_code', '');
              if (data.voucher_code) {
                data.voucher_error_modal = response.data.message;
              } else {
                commit('invalid_voucher_message', response.data.message);
              }
            }
          })
          .catch((error) => {
            data.loading.voucher = false;
            commit('voucher_code', '');
            if (error.response.data && error.response.data.message) {
              if (data.voucher_code) {
                data.voucher_error_modal = error.response.data.message;
              } else {
                commit('invalid_voucher_message', error.response.data.message);
              }
            } else {
              if (data.voucher_code) {
                data.voucher_error_modal = 'Terjadi kesalahan sistem';
              } else {
                commit('invalid_voucher_message', 'Terjadi kesalahan sistem');
              }
            }
            console.log(error);
          });
      } else {
        data.loading.voucher = false;
        commit('voucher_code', '');
        if (data.voucher_code) {
          data.voucher_error_modal = 'Kode Voucher harus diisi';
        } else {
          commit('invalid_voucher_message', 'Kode Voucher harus diisi');
        }
      }
    },
    // deleteRedeemDiscount({commit, state, dispatch}, data) {
    //     if (state.redeem_beauty_points) {
    //         data.$axios.delete(data.$customConfig.API.redeemBeautyPoints, {
    //             data: {
    //                 points: Number(state.redeem_beauty_points),
    //                 _id: state.dataOrder._id
    //             }
    //         }).then((res) => {
    //             if (res.status == 200) {
    //                 data.beauty_point_value = 0
    //                 commit('redeem_beauty_points', '')
    //                 dispatch('fetchCurrentUserCart').then((res) => {
    //                     data.loading.voucher = false
    //                     dispatch('getUpdateSocoPoint')
    //                 });
    //                 dispatch('updateCartPriceTotal', {'discount': 0})
    //             } else {
    //                 data.loading.voucher = false
    //             }
    //         }).catch((err) => {
    //             data.loading.voucher = false
    //         })
    //     } else {
    //         data.$axios.delete(data.$customConfig.API.redeemVoucher, {
    //             data: {
    //                 voucher_id: state.redeem_voucher,
    //                 _id: state.dataOrder._id
    //             }
    //         }).then((res) => {
    //             if (res.status == 200) {
    //                 state.voucher_code = ''
    //                 commit('redeem_voucher', '')
    //                 commit('voucher_code', '')
    //                 dispatch('fetchCurrentUserCart').then((res) => {
    //                     data.loading.voucher = false
    //                     dispatch('getUpdateSocoPoint')
    //                 });
    //                 dispatch('updateCartPriceTotal', {'discount': 0})
    //             } else {
    //                 data.loading.voucher = false
    //             }
    //         }).catch((err) => {
    //             data.loading.voucher = false
    //         })
    //     }
    // },
    cancelRedeemPoint({ commit, state }) {
      return axios.delete(this._vm.$customConfig.API.redeemBeautyPoints, {
        data: {
          points: Number(state.redeem_beauty_points),
          _id: state.dataOrder['_id'],
        },
      });
    },
    cancelRedeemVoucher({ commit, state }) {
      return axios.delete(this._vm.$customConfig.API.redeemVoucher, {
        data: {
          voucher_id: state.redeem_voucher,
          _id: state.dataOrder._id,
        },
      });
    },
    getVoucherDetail({ commit, rootState, state }, isInitial) {
      const $params = {
        fields: 'rules, discount_info, code, available_quota, voucher_type, voucher_info',
        filter: {
          'rules.users.id': `${rootState.$_Auth.user['_id']}`,
          discount_type: 'free_shipping',
          is_active: true,
        },
      };
      // const dataOrder = rootState.$_Header.dataOrder
      // const multiFreeShipping = Object.keys(state.freeShipping).length && state.freeShipping.length > 1
      // if (!isInitial && !multiFreeShipping && dataOrder && dataOrder.total_amount_after_discount) {
      //     $params.filter['amount'] = Number(dataOrder.total_amount_after_discount || 0)
      // }
      return axios
        .get(this._vm.$customConfig.API.vouchers, {
          params: $params,
        })
        .then((res) => {
          let activeVoucher;
          if (res.status == 200 && res.data.data && res.data.data[0]) {
            for (let i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].available_quota > 0 && res.data.data[i].voucher_type === 'manual') {
                commit('setUserVoucherCode', res.data.data[i].code);
              }
            }
            if (res.data.data.length > 1) {
              activeVoucher = res.data.data.sort((a, b) => {
                const voucherA =
                  a.rules.products || a.rules.brands || a.rules.categories
                    ? 0
                    : (a.rules.order && isNaN(Number(a.rules.order.min_amount))) ||
                      !a.rules.order ||
                      !Object.keys(a.rules.order).length
                    ? 0
                    : Number(a.rules.order.min_amount);
                const voucherB =
                  b.rules.products || b.rules.brands || b.rules.categories
                    ? 0
                    : (b.rules.order && isNaN(Number(b.rules.order.min_amount))) ||
                      !b.rules.order ||
                      !Object.keys(b.rules.order).length
                    ? 0
                    : Number(b.rules.order.min_amount);
                return voucherB - voucherA;
              });
              commit('freeShipping', activeVoucher);
            } else {
              commit('freeShipping', res.data.data);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateCartPriceTotal({ commit, state, dispatch }, data) {
      const newCartPriceTotal = Object.assign({}, state.cart_price_total, data);
      commit('cart_price_total', newCartPriceTotal);
    },
    sendNotifyMe({ commit, rootState }, data) {
      try {
        let payload = {};
        if (rootState.$_Products.notifyData && Object.keys(rootState.$_Products.notifyData).length) {
          payload = rootState.$_Products.notifyData;
          if (data.email) {
            payload.email = data.email;
          }
        } else {
          payload = {
            product_id: data.currentProductAttribute.product.id,
            combination_id: data.currentProductAttribute.product.combination_id,
            email: data.email,
          };
          if (data.$store.state.$_Auth.user) {
            payload.user = {
              id: data.$store.state.$_Auth.user.id,
              email: data.$store.state.$_Auth.user.email,
              name: data.$store.state.$_Auth.user.name,
            };
            if (!payload.email && payload.user && payload.user.email) {
              payload.email = payload.user.email;
            }
          }
        }
        data.$axios
          .post(data.$customConfig.API.notifyMe, payload)
          .then((res) => {
            if (res.status === 200) {
              commit('modalNotify', false);
              //commit('setModalSuccess', true)
              if (
                !(
                  rootState.$_Modal.notificationAddCart.data &&
                  Object.keys(rootState.$_Modal.notificationAddCart.data).length
                )
              ) {
                commit('$_Modal/SET_NOTIFICATION_ADD_CART_DATA', data.product, { root: true });
              }
              commit('$_Modal/SET_NOTIFICATION_ADD_CART_SOLD_OUT_PRODUCT', true, { root: true });
              commit('$_Modal/SHOW', 'notificationAddCart', { root: true });
            }
            if (data.loadingNotify) {
              data.loadingNotify = false;
            }
            if (data.email) {
              data.email = '';
            }
          })
          .catch((error) => {
            commit('modalNotify', false);
            commit('$_Modal/SET_NOTIFICATION_ADD_CART_SOLD_OUT_PRODUCT', true, { root: true });
            commit('$_Modal/SHOW', 'notificationAddCart', { root: true });
            data.$toasted.global.error('Terjadi kesalahan sistem');
            if (data.loadingNotify) {
              data.loadingNotify = false;
            }
            if (data.email) {
              data.email = '';
            }
            console.log(error);
          });
      } catch (e) {
        commit('modalNotify', false);
        //commit('setModalSuccess', true)
        commit('$_Modal/SET_NOTIFICATION_ADD_CART_SOLD_OUT_PRODUCT', true, { root: true });
        commit('$_Modal/SHOW', 'notificationAddCart', { root: true });
        data.loadingNotify = false;
      }
    },
    orderNav({ commit, state, dispatch }, data) {
      const order_nav = state.order_nav.slice(0);
      if (order_nav.indexOf(data) < 0) {
        order_nav.push(data);
      }
      commit('order_nav', order_nav);
    },
    orderNavCurrent({ commit, state, dispatch }, data) {
      commit('order_nav_current', data);
    },
    resetCart({ commit, state, dispatch }, data) {
      commit('RESET_CART');
    },
    setSidebarBrandTitle({ commit, state, dispatch }, data) {
      if (data.$route) {
        if (data.$route.params.manufactureId != undefined) {
          const brands = state.brands_menu;
          const currentBrand = brands.filter((item) => item.id_manufacturer === data.$route.params.manufactureId);
          if (currentBrand.length) {
            dispatch('$_Sidebar/setTitle', currentBrand[0].name, { root: true });
          }
        } else if (data.$route.name == 'Search') {
          dispatch('$_Sidebar/setTitle', '', { root: true });
        } else {
          dispatch('$_Sidebar/setTitle', '', { root: true });
        }
      } else {
        dispatch('$_Sidebar/setTitle', '', { root: true });
      }
    },
    // getCampaignStatus ({commit, state, dispatch}, data) {
    //     data.$axios.get(data.$customConfig.API.campaignStatus, {
    //         params: {
    //             filter: {
    //                 is_product_detail: false
    //             }
    //         }
    //     }).then(response => {
    //         if (response.status == 200 && response.data.data) {
    //             commit('CAMPAIGN_STATUS', response.data.data.is_display_icon_web)
    //             commit('LIST_CAMPAIGN_BANNER', response.data.data)
    //         }
    //     }).catch(error => {
    //     })
    // },
    getWishlist({ commit, state, dispatch }, { data, load_more = false }) {
      if (!state.processing.wishlist && state.skip.wishlist < 10 && load_more ? true : !state.first_fetched.wishlist) {
        state.first_fetched.wishlist = true;
        state.processing.wishlist = true;
        data.$axios
          .get(data.$customConfig.API.wishlist, {
            params: {
              skip: state.skip.wishlist,
              limit: state.limit.wishlist,
            },
          })
          .then((response) => {
            if (response.status == 200 && response.data.data) {
              if (load_more && state.list_wishlist && state.list_wishlist.length) {
                commit('LIST_WISHLIST', { data: response.data.data, merge: true });
              } else {
                commit('LIST_WISHLIST', { data: response.data.data });
              }
              state.skip.wishlist = state.skip.wishlist + state.limit.wishlist;
            }
            state.processing.wishlist = false;
          })
          .catch((error) => {
            state.processing.wishlist = false;
          });
      }
    },
    fetchVoucherPaperBag({ commit, state }) {
      state.loadingVoucherPaperBag = true;
      axios
        .get(`${this._vm.$customConfig.API.voucherPaperBag}`)
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            commit('SET_VOUCHER_PAPERBAG', response.data.data);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (state.loadingVoucherPaperBag = false));
    },

    getPeopleAlsoBuy({ commit, state, dispatch }, data) {
      data.$axios
        .get(data.$customConfig.API.peopleAlsoBuy)
        .then((response) => {
          if (response.status == 200 && response.data.data) {
            commit('LIST_PEOPLE_ALSO_BUY', response.data.data);
          }
        })
        .catch((error) => {});
    },
    getAllHomeBanner(
      { commit, state, rootState, dispatch },
      { data, all = false, force = false, is_promotion = false }
    ) {
      const default_ready =
        (state.bpomBanner && state.bpomBanner.length) ||
        (state.banner_teaser && state.banner_teaser.length) ||
        (state.promo_text && state.promo_text.length) ||
        (state.searchbar_promo_text && state.searchbar_promo_text.length);
      let locations = ['top_middle_banner', 'top_banners', 'promo_text_banner', 'searchbar_promo_text'];

      if (all || state.banner_called || state.popup_banner_closed) {
        const home_locations = [
          'home',
          'regular_flashsale_theme',
          'brand_launch',
          'daily_deals',
          'daily_deals_title',
          'fullscreen_popup_banner',
          'popup_banner',
          'emergency_anouncement',
          'flexible_banner',
          'featured_brand_title',
          'floating_icon_apps',
          'sociolla_logo_thematic',
          'title_flexible_banner',
          'floating_banners',
        ];
        locations = default_ready ? home_locations : locations.concat(home_locations);
      }

      let force_fetch = false;
      const is_promotion_page = is_promotion || data.$route.name == 'Promotion';
      if (is_promotion_page) {
        if (state.promotion_fetched.indexOf(data.$route.params.slug) == -1) {
          state.promotion_fetched.push(data.$route.params.slug);
          locations = default_ready ? ['popup_banner'] : [...locations, 'popup_banner'];
          if (state.all_banner_processing) {
            state.all_banner_processing = false;
            force_fetch = true;
          }
        }
      }

      if (
        all &&
        !(rootState.$_Modal.showBannerPopUp && rootState.$_Modal.showBannerPopUp.length) &&
        !state.popup_banner_closed &&
        state.promotion_fetched.length
      ) {
        state.all_banner_processing = false;
      }

      if (!state.all_banner_processing && (all ? true : !default_ready || force_fetch)) {
        state.all_banner_processing = true;
        data.$axios
          .get(`${data.$customConfig.API.allHomeBanner}/all`, {
            params: {
              filter: {
                locations: locations,
              },
            },
          })
          .then((response) => {
            if (response.status == 200 && response.data.data) {
              const res = response.data.data;
              if (res.top_banners && res.top_banners.length) {
                const top_banner_result = res.top_banners.length > 1 ? res.top_banners.slice(0, 2) : res.top_banners;
                commit('BANNER_TEASER', top_banner_result);
              }
              if (res.floating_banners && res.floating_banners.length) {
                const floating_banners =
                  res.floating_banners.length > 1 ? res.floating_banners.slice(0, 2) : res.floating_banners;
                commit('BANNER_FLOATING', floating_banners);
              }
              if (res.promo_text_banner && res.promo_text_banner.length) {
                commit('PROMO_TEXT', res.promo_text_banner);
              }
              if (res.top_middle_banner && res.top_middle_banner.length) {
                commit('setBpomBanner', [res.top_middle_banner[0]]);
              }
              if (res.flexible_banner && res.flexible_banner.length) {
                commit('FLEXIBLE_BANNER', res.flexible_banner);
              }
              if (res.home && res.home.length) {
                commit('MAIN_BANNER', res.home);
              }
              if (res.regular_flashsale_theme) {
                commit('FLASH_SALE_THEME', res.regular_flashsale_theme[0]);
              }
              if (res.brand_launch && res.brand_launch.length) {
                commit('BRAND_LAUNCH', [res.brand_launch[0]]);
              }
              if (res.daily_deals && res.daily_deals.length) {
                commit('DAILY_DEALS', res.daily_deals);
              }
              if (res.daily_deals_title && res.daily_deals_title.length) {
                commit('DAILY_DEALS_TITLE', res.daily_deals_title);
              }
              if (res.featured_brand_title && res.featured_brand_title.length) {
                commit('FEATURED_BRAND_TITLE', res.featured_brand_title);
              }
              if (res.floating_icon_apps && res.floating_icon_apps.length) {
                commit('FLOATING_ICON_APPS', res.floating_icon_apps);
              }
              if (res.sociolla_logo_thematic && res.sociolla_logo_thematic.length) {
                commit('SOCIOLLA_LOGO_THEMATIC', res.sociolla_logo_thematic[0]);
              }
              if (res.searchbar_promo_text && res.searchbar_promo_text.length) {
                commit('SEARCHBAR_PROMO_TEXT', res.searchbar_promo_text);
              }
              if (res.title_flexible_banner && res.title_flexible_banner.length) {
                commit('TITLE_FLEXIBLE_BANNER', res.title_flexible_banner);
              }
              if (res.popup_banner && res.popup_banner.length) {
                const get_id = rootState.$_Campaign.id_for_banner;
                const route_now = data.$route.name;
                let route_active = '';
                if (route_now == 'Home') {
                  route_active = 'home';
                }
                if (route_now == 'Category') {
                  route_active = 'category';
                }
                if (route_now == 'Manufacture') {
                  route_active = 'brand';
                }
                if (route_now == 'Promotion') {
                  route_active = 'sociolla_campaign';
                }

                const popup_banner_active = res.popup_banner.find((f) => {
                  if (f.apply_for && f.apply_for.length) {
                    const get_location = f.apply_for.find(
                      (value) => value.location == route_active && value.target.length
                    );
                    if (get_location) {
                      return get_location.location == 'home'
                        ? true
                        : get_location.target.find((value) => value.id == get_id);
                    }
                  }
                });
                if (popup_banner_active) {
                  if (popup_banner_active.more_info.apply) {
                    if (popup_banner_active.more_info.apply == 'everyday') {
                      const expired = 1000 * 60 * 60 * 24; // 24 Jam
                      const prev = localStorage.getItem(
                        `expired-banner-popup${is_promotion_page ? `-promotion-${get_id}` : ``}`
                      );
                      const now = new Date().getTime();
                      const not = prev == undefined;
                      const prev_expired = prev != undefined && now - prev > expired;

                      if (not || prev_expired) {
                        localStorage.setItem(
                          `expired-banner-popup${is_promotion_page ? `-promotion-${get_id}` : ``}`,
                          now
                        );
                        dispatch(
                          `$_Modal/showBannerPopUp${is_promotion_page ? `Promotion` : ``}`,
                          { content: popup_banner_active, data: data },
                          { root: true }
                        );
                      } else {
                        dispatch(`$_Modal/showBannerPopUp${is_promotion_page ? `Promotion` : ``}`, '', { root: true });
                        if (!is_promotion_page) {
                          commit('SET_POPUP_BANNER_CLOSED', true);
                        }
                      }
                    } else {
                      dispatch(
                        `$_Modal/showBannerPopUp${is_promotion_page ? `Promotion` : ``}`,
                        { content: popup_banner_active, data: data },
                        { root: true }
                      );
                    }
                  } else {
                    if (rootState.$_Modal[`showBannerPopUp${is_promotion_page ? `Promotion` : ``}`]) {
                      dispatch(`$_Modal/showBannerPopUp${is_promotion_page ? `Promotion` : ``}`, '', { root: true });
                      commit('SET_POPUP_BANNER_CLOSED', true);
                    }
                  }
                } else {
                  dispatch(`$_Modal/showBannerPopUp${is_promotion_page ? `Promotion` : ``}`, '', { root: true });
                  commit('SET_POPUP_BANNER_CLOSED', true);
                }
              }
              if (res.fullscreen_popup_banner && res.fullscreen_popup_banner.length) {
                if (res.fullscreen_popup_banner[0].more_info.apply) {
                  if (res.fullscreen_popup_banner[0].more_info.apply == 'everyday') {
                    const expired = 1000 * 60 * 60 * 24; // 24 Jam
                    const prev = localStorage.getItem('expired-fullscreen-banner-popup');
                    const now = new Date().getTime();
                    const not = prev == undefined;
                    const prev_expired = prev != undefined && now - parseInt(prev) > expired;
                    if (not || prev_expired) {
                      localStorage.setItem('expired-fullscreen-banner-popup', now);
                      dispatch(
                        '$_Modal/showFullScreenBannerPopUp',
                        { content: res.fullscreen_popup_banner[0], data: data },
                        { root: true }
                      );
                    } else {
                      dispatch('$_Modal/showFullScreenBannerPopUp', '', { root: true });
                      commit('SET_POPUP_BANNER_CLOSED', true);
                    }
                  } else {
                    dispatch(
                      '$_Modal/showFullScreenBannerPopUp',
                      { content: res.fullscreen_popup_banner[0], data: data },
                      { root: true }
                    );
                  }
                } else {
                  if (rootState.$_Modal.showFullScreenBannerPopUp) {
                    dispatch('$_Modal/showFullScreenBannerPopUp', '', { root: true });
                    commit('SET_POPUP_BANNER_CLOSED', true);
                  }
                }
              }
              if (res.emergency_anouncement && res.emergency_anouncement.length) {
                commit('EMERGENCIES', res.emergency_anouncement);
              }

              commit('LOADING_BANNER', false);
              state.call_all_banner = 0;
              // console.log(this.vm.$route)
              if (
                (res.popup_banner &&
                  !res.popup_banner.length &&
                  res.fullscreen_popup_banner &&
                  !res.fullscreen_popup_banner.length) ||
                rootState.currentUrl.name != 'Home'
              ) {
                commit('SET_POPUP_BANNER_CLOSED', true);
              }
            }
            if (!all) {
              state.all_banner_processing = false;
            }
            setTimeout(() => {
              commit('SET_BANNER_CALLED', true);
            }, 1000);
          })
          .catch((error) => {
            commit('LOADING_BANNER', false);
            state.call_all_banner++;
            if (state.call_all_banner <= 3) {
              dispatch('getAllHomeBanner', { data: data, all: all });
            }
            if (!all) {
              state.all_banner_processing = false;
            }
            setTimeout(() => {
              commit('SET_BANNER_CALLED', true);
            }, 1000);
            commit('SET_POPUP_BANNER_CLOSED', true);
          });
      }
    },
    getIntersection({ commit, state, rootState, dispatch }, { data, section = '', type = 'product' }) {
      const locations = [];
      if (section) {
        locations.push(section);
        commit('LOADING_INTERSECTION', { section: section, value: true });
        const endpoint = `${data.$customConfig.API.allHomeBanner}/all`;
        data.$axios
          .get(endpoint, {
            params: {
              filter: {
                locations: locations,
              },
            },
          })
          .then((response) => {
            if (response.status == 200 && response.data.data) {
              const res = response.data.data;
              if (res.sociolla_exclusive.length) {
                commit('INTERSECTION', { section: section, value: res.sociolla_exclusive });
              }
              commit('LOADING_INTERSECTION', { section: section, value: false });
            }
          })
          .catch((error) => {
            commit('LOADING_INTERSECTION', { section: section, value: false });
          });
      }
    },

    async checkOmnichannelStoresStock({ commit, state }) {
      if (state.omnichannel_stores_stock_loading || state.omnichannel_stores_stock_fetched) {
        return;
      }
      commit('set_omnichannel_stores_stock_loading', true);
      return axios
        .get(`${Config.MS_CART_API_URL}/user/me/carts/stores`)
        .then((res) => {
          if (res.status === 200) {
            const data = res.data.data;
            if (data.length) {
              commit('set_omnichannel_stores_stock', true);
            } else {
              commit('set_omnichannel_stores_stock', false);
            }
          }
        })
        .catch((err) => {
          commit('set_omnichannel_stores_stock', false);
        })
        .finally(() => {
          commit('set_omnichannel_stores_stock_loading', false);
          commit('set_omnichannel_stores_stock_fetched', true);
        });
    },
  },
  getters: {
    voucherForNewUser(state) {
      let voucherFirstPurchase = null;
      if (state.freeShipping && state.freeShipping.length) {
        state.freeShipping.forEach((voucher) => {
          if (voucher.rules.users && voucher.voucher_info && voucher.voucher_info.header === 'WELCOME VOUCHER') {
            voucherFirstPurchase = voucher;
          }
        });
      }
      return voucherFirstPurchase;
    },
    totalPrice(state) {
      if (state.dataOrder) {
        return state.dataOrder.total_extra_charge > 0
          ? state.dataOrder.total_amount_after_extra
          : state.dataOrder.total_amount_after_discount > 0
          ? state.dataOrder.total_amount_after_discount
          : 0;
      }
    },
    carts(state) {
      return state.mini_cart && state.mini_cart.length ? state.mini_cart : [];
    },
    freeShipping(state, getters) {
      if (state.freeShipping && Object.keys(state.freeShipping).length) {
        const freeShippingData = state.freeShipping;
        const carts = getters.carts;
        const total = getters.totalPrice;
        if (Array.isArray(freeShippingData) && freeShippingData.length) {
          let IDX;
          const checkAvailability = (freeShipping, type) => {
            if (!type) {
              return false;
            }
            const minAmount = freeShipping.rules.order && freeShipping.rules.order.min_amount;
            const maxDiscount = freeShipping.discount_info && freeShipping.discount_info.shipping_fee_discount;
            return freeShipping.rules[type].some(function (rule) {
              const ruleName = type === 'products' ? rule[0].name : rule.name;
              const ruleId = type === 'products' ? rule[0].id : rule.id;
              const productAtCart = carts.find((cart) => {
                if (type === 'brands' && cart.raw && cart.raw.brand) {
                  return cart.raw.brand.id === ruleId;
                }
                if (type === 'categories' && cart.raw && cart.raw.categories) {
                  return cart.raw.categories.some((c) => c.name === ruleName);
                }
                if (type === 'products' && cart.raw && cart.raw.id) {
                  return cart.raw.id === ruleId && cart.name === ruleName;
                }
              });
              if (!productAtCart) {
                return false;
              }
              const amountAtCart = productAtCart.raw.detail.combination.total_price;
              const fulfillAmount = minAmount ? amountAtCart >= minAmount : Boolean(maxDiscount) ? true : false;
              return (
                fulfillAmount ||
                Boolean(minAmount && maxDiscount) ||
                Boolean(minAmount && !maxDiscount) ||
                Boolean(!minAmount && maxDiscount) ||
                Boolean(!minAmount && maxDiscount === 0)
              );
            });
          };
          const freeShippingCheck = (fsh, index) => {
            const minAmount = fsh.rules.order && fsh.rules.order.min_amount;
            const maxDiscount = fsh.discount_info && fsh.discount_info.shipping_fee_discount;
            const brands = fsh.rules.brands && fsh.rules.brands.length;
            const categories = fsh.rules.categories && fsh.rules.categories.length;
            const products = fsh.rules.products && fsh.rules.products.length;
            if (!brands && !categories && !products) {
              const fulfillAmount = minAmount ? total >= minAmount : Boolean(maxDiscount) ? true : false;
              const fulfilled =
                fulfillAmount ||
                Boolean(minAmount && maxDiscount) ||
                Boolean(minAmount && !maxDiscount) ||
                Boolean(!minAmount && maxDiscount) ||
                Boolean(!minAmount && maxDiscount === 0);
              if (fulfilled) {
                IDX = index;
              }
              return fulfilled;
            } else {
              const type = brands ? 'brands' : categories ? 'categories' : products ? 'products' : '';
              const available = checkAvailability(fsh, type);
              if (available) {
                IDX = index;
              }
              return available;
            }
          };
          const fulfillFreeShipping = freeShippingData.some(freeShippingCheck);
          return fulfillFreeShipping && !isNaN(Number(IDX)) ? freeShippingData[IDX] : undefined;
        } else {
          return freeShippingData;
        }
      }
    },
    freeShippingSpecific(state, getters) {
      const freeShipping = getters.freeShipping;
      if (freeShipping && Object.keys(freeShipping).length) {
        const nameGenerate = (name) => {
          return name.length > 2 ? name.slice(0, -1).join(', ') + ' atau ' + name.slice(-1) : name.join(' atau ');
        };
        if (freeShipping.rules && freeShipping.rules.products && freeShipping.rules.products.length) {
          const name = new Set(
            freeShipping.rules.products.map((pr) => {
              return pr[0].name;
            })
          );
          return 'produk ' + nameGenerate(Array.from(name));
        }
        if (freeShipping.rules && freeShipping.rules.categories && freeShipping.rules.categories.length) {
          const name = new Set(
            freeShipping.rules.categories.map((cat) => {
              return cat.name;
            })
          );
          return 'kategori ' + nameGenerate(Array.from(name));
        }
        if (freeShipping.rules && freeShipping.rules.brands && freeShipping.rules.brands.length) {
          const name = new Set(
            freeShipping.rules.brands.map((brand) => {
              return brand.name;
            })
          );
          return 'brand ' + nameGenerate(Array.from(name));
        }
      }
    },
    isFreeShipping(state, getters) {
      const fs = getters.freeShipping;
      if (fs && Object.keys(fs).length) {
        const minAmount = fs.rules && fs.rules.order && fs.rules.order.min_amount;
        const maxDiscount = fs.discount_info && fs.discount_info.shipping_fee_discount;
        const carts = getters.carts;
        const total = getters.totalPrice;
        if (fs.rules.brands && fs.rules.brands.length) {
          return fs.rules.brands.some(function (brand, idx) {
            const brandAtCart = carts.find((c) => c.raw.brand.id === brand.id);
            const amountAtCart = brandAtCart.raw.detail.combination.total_price;
            return minAmount ? amountAtCart >= minAmount : Boolean(maxDiscount) ? true : false;
          });
        }
        if (fs.rules.categories && fs.rules.categories.length) {
          return fs.rules.categories.some(function (category, idx) {
            const categoryAtCart = carts.find((cart) => cart.raw.categories.some((c) => c.name === category.name));
            const amountAtCart = categoryAtCart.raw.detail.combination.total_price;
            return minAmount ? amountAtCart >= minAmount : Boolean(maxDiscount) ? true : false;
          });
        }
        if (fs.rules.products && fs.rules.products.length) {
          return fs.rules.products.some(function (prd, idx) {
            const productAtCart = carts.find((cart) => cart.raw.id === prd[0].id && cart.name === prd[0].name);
            const amountAtCart = productAtCart.raw.detail.combination.total_price;
            return minAmount ? amountAtCart >= minAmount : Boolean(maxDiscount) ? true : false;
          });
        }
        if ((!minAmount && Boolean(maxDiscount)) || Boolean(!minAmount && maxDiscount === 0) || minAmount === 0) {
          return true;
        }
        if (minAmount > 0 && total >= minAmount) {
          return true;
        }
        return false;
      }
      return false;
    },
    listDangerousProducts: (state) => {
      const listCart = state.mini_cart.filter((cart) => cart.raw.is_dangerous);
      let listGwp = [];
      if (state.dataOrder.free_products && state.dataOrder.free_products.length) {
        listGwp = state.dataOrder.free_products.filter((cart) => cart.product.is_dangerous);
      }
      return listCart.concat(listGwp);
    },
    isGWPDangerousProductsInCart: (state) => {
      let isDangerousGWP = false;
      if (state.dataOrder.free_products && state.dataOrder.free_products.length) {
        isDangerousGWP = state.dataOrder.free_products.filter((cart) => cart.product.is_dangerous).length > 0;
      }
      return isDangerousGWP;
    },
    availableGuestCheckoutCart(state) {
      if (state.mini_cart.length) {
        const productOrder = state.mini_cart.findIndex((item) => item.raw.detail.combination.available_for_guest) > -1;
        return productOrder || false;
      }
      return false;
    },
    department_menu: (state) => state.department_menu,
    brands_menu: (state) => state.brands_menu,
    cart_price: (state) =>
      state.mini_cart.reduce((accu, item) => {
        if (item.raw.detail.combination.price_after_discount) {
          accu += get(item, 'raw.detail.combination.price_after_discount', 0) * get(item, 'qty', 0);
        } else {
          accu += get(item, 'raw.detail.combination.price', 0) * get(item, 'qty', 0);
        }

        return accu;
      }, 0),
    cart_price_final: (state) =>
      state.mini_cart.reduce((accu, item) => {
        if (item.raw.detail.combination.price_after_discount) {
          accu += get(item, 'raw.detail.combination.price_after_discount', 0) * get(item, 'qty', 0);
        } else {
          accu += get(item, 'raw.detail.combination.price', 0) * get(item, 'qty', 0);
        }

        if (state.cart_price_total.discount) {
          if (accu + state.cart_price_total.discount < 0) {
            accu = 0;
          } else {
            accu = accu + state.cart_price_total.discount;
          }
        }

        return accu;
      }, 0),
  },
};
